<template>
  <v-app>
    <!-- <top-nav /> -->
    <the-header />
    <the-alerts />
    <div class="main-parent">
      <v-main id="main">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.path"></router-view>
        </transition>
        <the-footer></the-footer>
      </v-main>
    </div>
    <the-loading />
  </v-app>
</template>

<script>
// import TopNav from "@/components/dashboard/TopNav.vue";
import TheHeader from "@/containers/TheHeader";
import TheAlerts from "@/components/TheAlerts";
import TheLoading from "@/components/TheLoading";
import TheFooter from "@/containers/TheFooter.vue";

export default {
  name: "TheContainer",
  components: {
    // TopNav,
    TheHeader,
    TheAlerts,
    TheLoading,
    TheFooter,
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
